export default __webpack_public_path__ + "static/media/event_fixed_banner.c8bd4df6.jpg";